import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar';
import Footer from './components/footer';
import Home from './components/pages/home';
import About from './components/pages/about';
import Products from './components/pages/product';
import ProductDetails from './components/productdetail';
import Contact from './components/pages/contact';
import Quote from './components/pages/quoatation';
import productsData from './components/data/products.json';
import ScrollToTop from './components/scrolltotop';
import Loader from './components/loader'; 
import './App.css';

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 3000); // loading time
  }, []);

  return (
    <Router>
      <ScrollToTop />
      {loading ? (
        <Loader />
      ) : (
        <div className="app">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products products={productsData.products} />} />
              <Route path="/product/:id" element={<ProductDetails products={productsData.products} />} />
              <Route path="/ordernow" element={<Quote />} />
              <Route path="/contact" element={<Contact />} />

              <Route path="*" element={
                <div className="not-found">
                  <h1>404 - Page Not Found</h1>
                  <p>The page you're looking for doesn't exist.</p>
                </div>
              } />
            </Routes>
          </main>
          <Footer />
        </div>
      )}
    </Router>
  );
};

export default App;
